import React from 'react';
import { Box, TextField, Button } from '@mui/material';
import StopIcon from '@mui/icons-material/Stop';
import SendIcon from '@mui/icons-material/Send';

const CodiInputBar = ({
  isClassic,
  userInput,
  onChange,
  onKeyDown,
  placeholder,
  placeholderFade = true,
  streaming,
  onStop,
  onSend,
  disabled = false
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-end' }}>
      <TextField
        fullWidth
        multiline
        minRows={1}
        maxRows={4}
        placeholder={placeholder}
        value={userInput}
        onChange={onChange}
        onKeyDown={onKeyDown}
        // Kein automatischer Fokus beim Laden, damit der Dialog ruhiger wirkt
        disabled={streaming || disabled}
        variant="outlined"
        size="medium"
        sx={(theme) => ({
          '& .MuiOutlinedInput-root': {
            borderRadius: isClassic ? '4px' : '24px',
            bgcolor: theme.palette.mode === 'dark' ? theme.palette.background.paper : 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(10px)',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            '&:hover:not(.Mui-disabled)': { boxShadow: '0 4px 16px rgba(0,0,0,0.12)', transform: 'translateY(-1px)' },
            '&.Mui-focused': {
              // Fokus dezenter färben
              boxShadow: theme.palette.mode === 'dark'
                ? '0 4px 14px rgba(255,107,71,0.20), 0 0 0 1px rgba(255,107,71,0.35)'
                : '0 6px 20px rgba(74, 144, 226, 0.25)',
              borderColor: theme.palette.mode === 'dark' ? 'rgba(255,107,71,0.35)' : 'primary.main',
              transform: 'translateY(-2px)'
            },
            '& textarea': { transition: 'height 0.2s ease-out' }
          },
          '& input::placeholder, & textarea::placeholder': {
            color: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.4)' : 'rgba(0, 0, 0, 0.38)',
            opacity: placeholderFade ? 1 : 0,
            transition: 'opacity 0.6s ease-in-out'
          }
        })}
      />

      {streaming ? (
        <Button
          variant="outlined"
          color="primary"
          onClick={onStop}
          endIcon={<StopIcon />}
          sx={{
            minWidth: '110px',
            minHeight: '42px',
            borderRadius: isClassic ? '4px' : '24px',
            borderWidth: '2px',
            fontWeight: 600,
            boxShadow: '0 2px 8px rgba(74, 144, 226, 0.2)',
            transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
            '&:hover': { borderWidth: '2px', backgroundColor: 'rgba(74, 144, 226, 0.1)', boxShadow: '0 4px 16px rgba(74, 144, 226, 0.3)', transform: 'translateY(-2px) scale(1.02)' }
          }}
        >
          Stop
        </Button>
      ) : (
        <Button
          variant="contained"
          color="primary"
          onClick={onSend}
          disabled={disabled || !userInput.trim()}
          endIcon={<SendIcon />}
          sx={{
            minWidth: '110px',
            minHeight: '42px',
            borderRadius: isClassic ? '4px' : '24px',
            boxShadow: '0 4px 16px rgba(74, 144, 226, 0.3)',
            transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
            fontWeight: 600,
            '&:hover:not(:disabled)': { boxShadow: '0 8px 24px rgba(74, 144, 226, 0.5)', transform: 'translateY(-2px) scale(1.02)' },
            '&:not(:disabled)': { animation: userInput.trim() ? 'pulse 2s ease-in-out infinite' : 'none' },
            '@keyframes pulse': { '0%, 100%': { boxShadow: '0 4px 16px rgba(74, 144, 226, 0.3)' }, '50%': { boxShadow: '0 4px 20px rgba(74, 144, 226, 0.5)' } }
          }}
        >
          Senden
        </Button>
      )}
    </Box>
  );
};

export default CodiInputBar;
